import fy2Api from '@/api/fy2Api';
import BaseModule from "@/common/BaseModule";
import { Module, Store } from "vuex";
import { LOAD_CHANNELS_CHANNEL, LOAD_CHANNELS_ROOT, SEO } from '../protocols';

export interface State {
    id: number,
    info: ChannelInfo,
    currNav: string,
    page: number,
    pageSize: number,
    total: number,
    movies: any[],
    shorts: any[],
    articles: any[],
    artists: any[],
    comments: any[],
}

class ChannelsChannel extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_CHANNEL[0])
    }

    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                id: 0,
                info: {
                    id: 0,
                    title: '',
                    thumb: '',
                    letter: '',
                    intro: '',
                    yd_username: '',
                    plays: 0,
                    likes: 0,
                    menus: [],
                } as ChannelInfo,
                currNav: '',
                page: 0,
                pageSize: 28,
                total: 0,
                movies: [],
                shorts: [],
                articles: [],
                artists: [],
                comments: [],
            },
            actions: {
                async loadData({ state, dispatch, commit }, route: Route) {
                    let id = parseInt(route.params.id)
                    if (isNaN(id)) {
                    } else {
                        state.id = id
                        state.info = await fy2Api.getChannelDetail(id)
                        const seoTitle = state.info.title + '-频道-福音影视网|福音TV'
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    }
                },
                async loadMovies({ state }, { params }: Route) {
                    state.currNav = 'album'
                    if (state.id > 0) {
                        let page = parseInt(params.page) || 0
                        state.page = page
                        let movies = await fy2Api.getChannelMovies(state.id, page + 1, state.pageSize)
                        state.movies = movies.list || []
                        state.total = movies.count
                    }
                },
                async loadShorts({ state }) {
                    state.currNav = 'short_video'
                    if (state.id > 0) {
                        let data = await fy2Api.getChannelShorts(state.id)
                        state.shorts = data.list
                    }
                },
                async loadArticles({ state }) {
                    state.currNav = 'yuedu'
                    if (state.id > 0) {
                        let data = await fy2Api.getChannelFeeds(state.id)
                        state.articles = data
                    }
                },
                async loadArtists({ state }) {
                    state.currNav = 'speaker'
                    if (state.id > 0) {
                        let data = await fy2Api.getChannelArtists(state.id)
                        state.artists = data.list
                    }
                },
                async loadComments({ state }) {
                    state.currNav = 'response'
                    if (state.id > 0) {
                        let { list, count } = await fy2Api.getChannelComments(state.id)
                        state.comments = list
                    }
                },
                [LOAD_CHANNELS_CHANNEL[1]]({ dispatch, commit, state }, route: Route) {
                    const seoTitle = '频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    state.movies = []
                    state.shorts = []
                    state.artists = []
                    state.comments = []
                    state.articles = []
                    let next = [
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadData', route)
                    ]
                    if (route.path.indexOf('movies') >= 0) {
                        next.push(dispatch('loadMovies', route))
                    } else if (route.path.indexOf('shorts') >= 0) {
                        next.push(dispatch('loadShorts', route))
                    } else if (route.path.indexOf('yuedus') >= 0) {
                        next.push(dispatch('loadArticles', route))
                    } else if (route.path.indexOf('speekers') >= 0) {
                        next.push(dispatch('loadArtists', route))
                    } else if (route.path.indexOf('comments') >= 0) {
                        next.push(dispatch('loadComments', route))
                    } else {
                        next.push(dispatch('loadMovies', route))
                    }
                    return Promise.all(next)
                }
            }
        }
    }

    loadMovies(store: Store<any>) {
        store.dispatch(this.key('loadMovies'))
    }

    loadShorts(store: Store<any>) {
        store.dispatch(this.key('loadShorts'))
    }

    loadArticles(store: Store<any>) {
        store.dispatch(this.key('loadArticles'))
    }

    loadArtists(store: Store<any>) {
        store.dispatch(this.key('loadArtists'))
    }

    loadComments(store: Store<any>) {
        store.dispatch(this.key('loadComments'))
    }
}

export default new ChannelsChannel()